import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatListItem, MatNavList } from '@angular/material/list';
import { MatTooltip } from '@angular/material/tooltip';
import { AppHelpers } from '@app/core/shared/helpers/app-helpers';
import { MaterialSymbol } from 'material-symbols';
import { SidebarStateService } from '../sidebar-state.service';

@Component({
  selector: 'app-sidebar-help',
  imports: [MatIcon, MatButton, MatListItem, MatNavList, MatTooltip],
  templateUrl: './sidebar-help.component.html'
})
export class SidebarHelpComponent {
  private readonly sidebarStateService = inject(SidebarStateService);

  protected readonly localLibraryIcon: MaterialSymbol = 'local_library';
  protected readonly contactSupportIcon: MaterialSymbol = 'contact_support';

  $isSidebarExpanded = this.sidebarStateService.isExpanded;

  readonly helpDeskLink = AppHelpers.HELPDESK_URL;
  readonly knowledgeBaseLink = AppHelpers.KNOWLEDGE_BASE_URL;

  goToUrl(url: string): void {
    window.open(url, '_blank');
  }
}
